























import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component
export default class AddressesFormGoogleMapsView extends Vue {
  @Prop({default: null}) defaultLatitude!: number | null;
  @Prop({default: null}) defaultLongitude!: number | null;

  private latitude: number | null = null;
  private longitude: number | null = null;
  private center = {lat: 35.699721152225635, lng: 51.33803844451904};
  private errorMessage: string | null = null;
  private mapOptions = {
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
  };

  clickedOnMap(event: any) {
    this.errorMessage = null;
    this.latitude = event.latLng.lat();
    this.longitude = event.latLng.lng();
  }

  saveMapLocation() {
    if (this.latitude && this.longitude) {
      this.errorMessage = null;
      this.$emit('saveMapLocation', {latitude: this.latitude, longitude: this.longitude});
    } else {
      this.errorMessage = "لطفا آدرس را روی نقشه علامت بزنید.";
    }
  }

  skipMapLocation() {
    this.$emit('skipMapLocation');
  }

  setPlace(place: any) {
    this.center.lat = place.geometry.location.lat();
    this.center.lng = place.geometry.location.lng();
  }

  mounted() {
    if (this.defaultLatitude && this.defaultLongitude) {
      this.latitude = this.defaultLatitude;
      this.center.lat = this.defaultLatitude;
      this.longitude = this.defaultLongitude;
      this.center.lng = this.defaultLongitude;
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center.lat = position.coords.latitude;
        this.center.lng = position.coords.longitude;
        /* this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };*/
      });
    }
  }

  get mapMarker() {
    if (this.latitude && this.longitude) {
      return {
        lat: this.latitude,
        lng: this.longitude
      }
    } else {
      return null;
    }
  }
}
